import { ActionFunctionArgs, redirect } from "@remix-run/cloudflare";
import { Form, Link } from "@remix-run/react";
import { drizzle } from "drizzle-orm/d1";

import { generatePassword, initializeLucia, verifyPassword } from "~/db/models/auth.server";
import * as schema from "~/db/schema.server";
import { Button } from "~/ui/Button";
import { Input } from "~/ui/Input";
import { badRequest } from "~/utils/response.server";

export default function Signup() {
  return (
    <Form method="POST" className="flex flex-col gap-4 max-w-sm w-full mx-auto mt-4">
      <p className="font-title text-xl">
        Predict the podium, and 4 other drivers for each race to beat your friends and follow Grand Prix with attention!
      </p>
      <label className="flex flex-col gap-1" htmlFor="name">
        name
        <Input type="text" name="name" />
      </label>
      <label className="flex flex-col gap-1" htmlFor="email">
        e-mail
        <Input type="email" name="email" />
      </label>
      <label className="flex flex-col gap-1" htmlFor="password">
        password
        <Input type="password" name="password" />
      </label>
      <label className="flex flex-col gap-1" htmlFor="confirmPassword">
        confirm password
        <Input type="password" name="confirmPassword" />
      </label>

      <div className="flex flex-col items-center gap-y-2 mt-2">
        <Button type="submit">Sign up</Button>
        <Link to="/login">Already have an account</Link>
      </div>
    </Form>
  );
}

export async function action({ request, context }: ActionFunctionArgs) {
  const lucia = initializeLucia(context);
  const db = drizzle(context.cloudflare.env.DB, { schema, logger: false });

  const body = await request.formData();

  const name = body.get("name") as string;
  const email = body.get("email") as string;
  const password = body.get("password") as string;
  const confirmPassword = body.get("confirmPassword") as string;

  if (password !== confirmPassword) {
    throw badRequest({ message: "password don't match" });
  }

  const existingUser = await db.query.user.findFirst({
    where: (user, { eq }) => eq(user.email, email),
  });

  if (existingUser) {
    throw badRequest({ message: "Email is already taken." });
  }

  const [user] = await db
    .insert(schema.user)
    .values({
      name,
      email,
      passwordHash: await generatePassword(password),
      timezoneOffset: 0,
      timezone: "",
    })
    .returning();

  const session = await lucia.createSession(user.id, {});
  const sessionCookie = lucia.createSessionCookie(session.id);

  return redirect(`/${new Date().getFullYear()}`, {
    headers: {
      "Set-Cookie": sessionCookie.serialize(),
    },
  });
}
